import type {
  SmsTrackingListResponse,
  SmsTrackingPeriod,
  SmsTrackingStatsResponse,
  SmsTrackingStatus,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export interface FetchSmsTrackingListParams {
  period: SmsTrackingPeriod
  page?: number
  pageSize?: number
  search?: string
  storeId?: number
  status?: SmsTrackingStatus
}

export const fetchSmsTrackingList = async (params: FetchSmsTrackingListParams) => {
  const response = await gozokiApiWithAuth.get<SmsTrackingListResponse>(
    '/hr/planning/sms-tracking',
    { params },
  )
  return response.data
}

export interface FetchSmsTrackingStatsParams {
  period: SmsTrackingPeriod
  storeId?: number
}

export const fetchSmsTrackingStats = async (params: FetchSmsTrackingStatsParams) => {
  const response = await gozokiApiWithAuth.get<SmsTrackingStatsResponse>(
    '/hr/planning/sms-tracking/stats',
    { params },
  )
  return response.data
}
